// extracted by mini-css-extract-plugin
export default {"menu-item":"LoginPage_menu-item__masco","login-container":"LoginPage_login-container__rwYeW"};